import { ioExtend, ioGuid, QueryParams } from '@framework';

export class RoleModel {
    UserRoleID = null;
    ParentID = null;
    Name = null;
    Status = null;
    isNew = true;

    constructor(_Role?: {}) {
        if (_Role) {
            this.isNew = false;
        } else {
            this.UserRoleID = ioGuid.New();
        }
        ioExtend(this, _Role);
    }

    toJSONData() {
        return JSON.stringify(this);
    }

    toQueryParamData() {
        return QueryParams.stringify(this);
    }
}